<template>
	<sBox>
		<div slot="body">
			<div class="row">
				<div class="col-sm-1">
					<b>Num</b>
					<input v-model="cod" type="text" class="form-control" />
				</div>
				<div class="col-sm-4">
					<b>CNPJ \ Razão social</b>
					<input v-model="cnpj" type="text" class="form-control" />
				</div>
				<div class="col-sm-2">
					<b>Região</b>
					<select v-model="regiao" class="form-control">
						<option value="all">Todas</option>
						<option
							v-for="(reg, index) in assets.regioes"
							:key="index"
							:value="reg.regiao"
						>
							{{ reg.localidade }}
						</option>
					</select>
				</div>
				<div class="col-sm-2">
					<b>Vendodores</b>
					<select v-model="vendedor" class="form-control">
						<option value="all">Todos</option>
						<option
							v-for="(ved, index) in assets.vendedores"
							:key="index"
							:value="ved.cod"
						>
							{{ ved.vendedor }}
						</option>
					</select>
				</div>

				<div class="col-sm-3">
					<b>Intervalo</b>
					<div class="input-group">
						<span class="input-group-addon">
							<i class="fa fa-calendar"></i>
						</span>
						<div class="form-control" id="datepicker-trigger">
							{{ fDate(dateOne) }} - {{ fDate(dateTwo) }}
						</div>
					</div>
					<div class="cnt-airbnb">
						<div class="airbnb">
							<AirbnbStyleDatepicker
								id="wrapper-date"
								trigger-element-id="datepicker-trigger"
								:mode="'range'"
								:months-to-show="2"
								:date-one="dateOne"
								:date-two="dateTwo"
								:fullscreen-mobile="true"
								@date-one-selected="
									(val) => {
										dateOne = val;
									}
								"
								@date-two-selected="
									(val) => {
										dateTwo = val;
									}
								"
							/>
							<!--
						        @closed='update' -->
						</div>
					</div>
				</div>
			</div>
		</div>
	</sBox>
</template>
<script>
	import sBox from 'box';
	import fDate from 'js/date';
	import WBS from 'js/http';

	export default {
		components: { sBox },
		data() {
			let iniData = new Date();
			iniData.setMonth(iniData.getMonth() - 1);

			let hoje = new Date();
			hoje.setDate(hoje.getDate() + 15);
			return {
				cod: '',
				cnpj: '',
				regiao: 'all',
				vendedor: 'all',
				dateOne: iniData,
				// dateOne: '2019-01-01',
				dateTwo: hoje,

				assets: {
					regioes: [],
					vendedores: [],
				},
			};
		},
		methods: {
			fDate(data, mask = 'DD xmxs') {
				let date = new Date(data);
				date.setDate(date.getDate() + 1);
				return fDate(date, mask);
			},
			update() {
				let filter = [];
				if (this.cod != '') filter.push(`cod = ${this.cod}`);

				let subNivel = false;
				if (this.cnpj != '') {
					subNivel = true;
					filter.push({
						table: 'clientes',
						find: 'cnpj',
						where: `cnpj like '%${this.cnpj}%' or razao_social like '%${this.cnpj}%'`,
					});
				}

				if (this.regiao != 'all')
					filter.push(`regiao = '${this.regiao}'`);
				if (this.vendedor != 'all')
					filter.push(`cod_vendedor = '${this.vendedor}'`);

				filter.push(
					` ( data > '${this.fDate(
						this.dateOne,
						'YY-MM-DD'
					)}' and data < '${this.fDate(this.dateTwo, 'YY-MM-DD')}' ) `
				);

				filter.push(" ( status = '' or status = 'CC' ) ");

				if (subNivel) this.$emit('updateTab', filter);
				else this.$emit('updateTab', filter.join(' and '));

				// return filter.join(' and ')
			},
		},
		mounted() {
			WBS.send('protected-read-assetsPropostas', (resp) => {
				if (resp.status == 'success') {
					this.assets = resp.data;
				}
			});
			$('.form-control').change(this.update);
			$('.action-buttons > button:nth-child(2)').click(this.update);
		},
	};
</script>
<style></style>



// WEBPACK FOOTER //
// src/components/proposals/components/filter.vue